"use client"

import { Desktop } from "@/lib/common/MediaQueries"
import { SearchHeroBannerWithText } from "@/lib/common/searchHeroBanners"
import styled from "@emotion/styled"
import { createContext, useContext } from "react"
import CustomBreadcrumbs from "../shared/CustomBreadcrumbs"
import SearchHero from "./SearchHero"

// Lets Search drop its own desktop breadcrumbs when the hero bar already shows them.
const SearchHeroContext = createContext(false)

export const useHasSearchHero = (): boolean => useContext(SearchHeroContext)

// With a hero, desktop breadcrumbs sit above it in their own bar (per design).
const BreadcrumbsBar = styled.div`
  padding: 0 40px;
  & > :not(style) {
    padding: 16px 0;
  }
`

type Props = {
  banners: SearchHeroBannerWithText[]
  children: React.ReactNode
}

// Rendered from app/search/layout so the hero survives navigation between
// /search and /search/[brandName] (brand-page filters route to /search).
export default function SearchHeroLayout({ banners, children }: Props): React.ReactElement {
  const hasHero = banners.length > 0
  return (
    <SearchHeroContext.Provider value={hasHero}>
      {hasHero && (
        <>
          <Desktop>
            <BreadcrumbsBar>
              <CustomBreadcrumbs
                current={{ title: "לכל ההצעות", url: "/search" }}
                parents={[{ title: "ראשי", url: "/" }]}
              />
            </BreadcrumbsBar>
          </Desktop>
          <SearchHero banners={banners} />
        </>
      )}
      {children}
    </SearchHeroContext.Provider>
  )
}
